import React from "react";
import { Navigate } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import { ProgressSpinner } from "primereact/progressspinner";
import { Spinner } from "../../pages/CRUDPages/CRUDPages.styles";

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const { user, initialized, loading } = useAppSelector((state) => state.auth);

  if (!initialized || loading) {
    return (
      <Spinner>
        <ProgressSpinner />
      </Spinner>
    );
  }

  return user ? <>{children}</> : <Navigate to="/login" replace />;
};

export default PrivateRoute;
